import {createFileRoute, useNavigate} from "@tanstack/react-router";
import {ToggleBar, ToggleBarIcon, toggleSwitchButtonSx, toggleSwitchSx} from "../../../components/ToggleBar.tsx";
import {BundleCargoView} from "../../../bundle/cargo.tsx";
import {useNaviScratchBlockDispatch} from "../../../navi/Navi.tsx";
import {watchBundleByIdTqo} from "../../../rpc/webrpc-client.gen.ts";
import {useEffect} from "react";
import {facetIcons} from "../../../components/Facet.tsx";
import {useBundleActions} from "../../../bundle/bundle.tsx";
import {ActionButton} from "../../../components/ActionButton.tsx";
import {SuspenseDialog} from "../../../components/SuspenseDialog.tsx";
import {useInfallibleQuery} from "../../../util/useInfallibleQuery.tsx";
import {useBomb} from "../../../bomb/bomb.tsx";
import {PageBody, PageHeader, PageShell} from "../../../routing/shell.tsx";
import {TopBar} from "../../../components/TopBar.tsx";
import {Button, Stack, ToggleButtonGroup} from "@mui/joy";
import {useMothership} from "../../../tq/tqx.tsx";

function BundleCargoPage() {
    const {id: bundleId} = Route.useParams();

    const dispatchScratchNaviItem = useNaviScratchBlockDispatch();
    const mama = useMothership();
    const bundleTqrv = useInfallibleQuery(watchBundleByIdTqo(mama, {bundleId}));
    const bundle = bundleTqrv.data;
    useEffect(() => {
        if (bundle) {
            dispatchScratchNaviItem({
                to: Route.to,
                params: {id: bundleId},
                icon: {icon: facetIcons.cargo},
                children: bundle.displayName,
            });
        }
    }, [dispatchScratchNaviItem, bundle, bundleId]);
    const navigate = useNavigate();
    const bomb = useBomb();
    const actionPropsTqrv = useBundleActions({bundleId});

    if (bundleTqrv.isPending || actionPropsTqrv.isPending) {
        return <SuspenseDialog message="fetching bundle..."/>
    }

    const actionProps = actionPropsTqrv.data;
    return <PageShell>
        <PageHeader>
            <TopBar/>
            <ToggleBar>
                <ToggleButtonGroup value="cargo" onChange={(_, next) => {
                    if (next) {
                        navigate({to: `/bundle/$id/${next}`, params: {id: bundleId}})
                            .catch(bomb);
                    }
                }} color="primary" sx={toggleSwitchSx}>
                    <Button sx={toggleSwitchButtonSx} value="cargo">
                        <ToggleBarIcon icon={facetIcons.cargo}/>
                    </Button>
                    <Button sx={toggleSwitchButtonSx} value="timeline">
                        <ToggleBarIcon icon={facetIcons.timeline}/>
                    </Button>
                </ToggleButtonGroup>

                <Stack direction="row" spacing={1.8}>
                    {actionProps
                        ? actionProps.map(kap =>
                            <ActionButton size="lg" key={kap.key} {...kap.elem}/>)
                        : null}
                </Stack>
            </ToggleBar>
        </PageHeader>
        <PageBody>
            <Stack direction="column">
                <BundleCargoView bundleId={bundleId}/>
            </Stack>
        </PageBody>
    </PageShell>;
}

export const Route = createFileRoute("/_auth/bundle/$id/cargo")({
    component: BundleCargoPage,
});

